import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-banner-2.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="header-card">
    <div class="title-card" data-attribute="title-card">
      <p style="color: #ff7657">Our product universe</p>
      <h2>
        Different products. One shared vision.
      </h2>
    </div>
    <div class="desc-card" data-attribute="desc-card">
      <p>
        A growing ecosystem of products, united by thoughtful design, useful technology, and global ambition.
      </p>
    </div>
  </div>
  <div class="wrap-banner-image" data-attribute="wrap-banner-image">
    <img
      data-attribute="banner-image"
      src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae010e9addd40664660b860.webp?w=1920&q=100"
      alt=""
    />
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#fff',
  topPadding: true,
  bottomPadding: true,
});
